module.exports = __webpack_public_path__ + "img/bulletins_banner.d7fdc16b.jpg";